import { defineComponent, inject, reactive } from 'vue'
import LtDropdown from '@lit-element/components/dropdown'
import LtTooltip from '@lit-element/components/tooltip'
import { useNamespace } from '@lit-element/hooks'
import { EditorMdInjectionKey, mdToolbarItemProps } from '../editor-md-types'
import FontColor from './font-color'
import FontSize from './font-size'
import type { IEditorMdInjection, MdToolbarItemProps } from '../editor-md-types'

const ns = useNamespace('md-toolbar')

export default defineComponent({
  name: 'DMdToolbarItem',
  props: mdToolbarItemProps,
  setup(props: MdToolbarItemProps) {
    const config = reactive(props.config)
    const { showFullscreen, getEditorIns, t } = inject(
      EditorMdInjectionKey
    ) as IEditorMdInjection
    const getTooltipContent = (name?: string, shortKey?: string) => {
      if (!name && !shortKey) {
        return ''
      }
      if (name === 'fullscreen') {
        return `<center>${
          showFullscreen.value ? t(config.exitName!) : t(name)
        }</center>`
      }
      let n: string | undefined = undefined
      if (name?.includes('&')) {
        const temp = name.split('&')
        n = `${t(temp[0])} & ${t(temp[1])}`
      }
      return `<center>${n ?? t(name!) ?? ''}<br>${shortKey ?? ''}</center>`
    }

    const onToolbarItemClick = () => {
      const editorIns = getEditorIns()
      if (config.id === 'fullscreen') {
        showFullscreen.value = !showFullscreen.value
        if (window) {
          const event = new Event('resize')
          window.dispatchEvent(event)
        }
      }
      config.handler?.(editorIns, config.params)
    }

    return () => (
      <>
        {config.type === 'button' && (
          <LtTooltip hide-after={300}>
            {{
              default: () => (
                <span
                  class={ns.b('item')}
                  onClick={onToolbarItemClick}
                  innerHTML={
                    config.id === 'fullscreen'
                      ? showFullscreen.value
                        ? config.exitIcon
                        : config.icon
                      : config.icon
                  }
                ></span>
              ),
              content: () => (
                <span
                  class={ns.b('tip-content')}
                  innerHTML={getTooltipContent(config.name, config.shortKey)}
                ></span>
              ),
            }}
          </LtTooltip>
        )}
        {config.type === 'dropDown' && (
          <LtDropdown placement={'bottom-start'}>
            {{
              default: () => (
                <span>
                  <LtTooltip
                    placement={showFullscreen.value ? 'right' : 'top'}
                    content={getTooltipContent(config.name)}
                    hide-after={1000}
                  >
                    {{
                      default: () => (
                        <span
                          class={ns.b('item')}
                          onClick={() => config.handler?.()}
                          innerHTML={config.icon}
                        ></span>
                      ),
                      content: () => (
                        <span
                          class={ns.b('tip-content')}
                          innerHTML={getTooltipContent(config.name)}
                        ></span>
                      ),
                    }}
                  </LtTooltip>
                </span>
              ),
              dropdown: () => (
                <>
                  {config.component === 'FontSize' && <FontSize />}
                  {config.component === 'FontColor' && <FontColor />}
                </>
              ),
            }}
          </LtDropdown>
        )}
      </>
    )
  },
})
